import { render } from "./AddPlatFormReNew.vue?vue&type=template&id=49564e2a&scoped=true"
import script from "./AddPlatFormReNew.vue?vue&type=script&lang=js"
export * from "./AddPlatFormReNew.vue?vue&type=script&lang=js"

import "./AddPlatFormReNew.vue?vue&type=style&index=0&id=49564e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49564e2a"]])

export default __exports__